import { Button, Body } from '@teko/ds-mobile';
import { styled } from '@teko/ui';
import { useProductDetailState } from 'contexts';

export const UomItem: React.FC = () => {
  const { product } = useProductDetailState();
  return (
    <StyledButton>
      <Body level={1}>{product?.uomName}</Body>
      <span className="corner"></span>
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  position: relative;
  display: inline-block;
  padding: 8px;
  border: 1px solid #0200bc; /* viền xanh */
  border-radius: 8px; /* bo góc */
  background: #fff;
  font-size: 16px;
  color: #000;
  cursor: pointer;
  overflow: hidden;
  min-width: 72px;
  height: 36px;

  .corner {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 17px;
    height: 17px;
    background: #0200bc; /* màu góc gấp */
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
  }
  .corner::after {
    content: '✔';
    position: absolute;
    bottom: -4px;
    right: 3px;
    font-size: 8px;
    color: #fff; /* dấu check trắng */
  }
`;
